import { DataSource } from '@angular/cdk/collections';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { BehaviorSubject, merge, Observable, of } from 'rxjs';

import { LoggerService } from '../../shared/logger.service';
import { Page } from './page.model';
import { RestService } from './rest.service.interface';
import { catchError, map, startWith, switchMap } from 'rxjs/operators';

const PATH_FILE = 'app/protected/immerdrin/oase.datasource.ts';

/**
 * Data source to provide what data should be rendered in the table. Note that the data source
 * can retrieve its data in any way. In this case, the data source is provided a reference
 * to a common data base, ExampleDatabase. It is not the data source's responsibility to manage
 * the underlying data. Instead, it only needs to take the data and send the table exactly what
 * should be rendered.
 */
export class OaseDataSource<T> extends DataSource<T> {
	isWaitingForResponse = false;
  	afterDataIsLoaded: any;
	_filterChange: BehaviorSubject<string> = new BehaviorSubject('');
	_extraChange: BehaviorSubject<string> = new BehaviorSubject('');
	_reloadData: BehaviorSubject<boolean> = new BehaviorSubject(false);
	get filter(): string {
		return this._filterChange.value;
	}
	set filter(filter: string) {
		this._filterChange.next(filter);
	}
	get extra(): string {
		return this._extraChange.value;
	}
	set extra(extra: string) {
		this._extraChange.next(extra);
	}

	page: Page = new Page();
	content: T[] = [];

	constructor(private _dataService: RestService, private _paginator: MatPaginator, private _sort: MatSort, private _logger: LoggerService,
				afterDataIsLoaded?: any) {
		super();

		this._logger.debug(PATH_FILE+' - afterDataIsLoaded: '+afterDataIsLoaded);
	  	this.afterDataIsLoaded = afterDataIsLoaded;

		// Reset to the first page when the user changes the filter.
		this._filterChange.subscribe(() => (this._paginator.pageIndex = 0));
	    this._extraChange.subscribe(() => this._paginator.pageIndex = 0);
	}

	/** Connect function called by the table to retrieve one stream containing the data to render. */
	connect(): Observable<T[]> {
		this._logger.debug(PATH_FILE + ' - TABLE OaseDataSource connect');
		// Listen for any changes in the base data, sorting, filtering, or pagination
		const displayDataChanges = [
			this._sort.sortChange,
			this._filterChange,
			this._extraChange,
			this._paginator.page,
			this._reloadData
		];

		return merge(...displayDataChanges).pipe(
			startWith(null),
			switchMap(() => {
				this.isWaitingForResponse = true;
				this._logger.debug(PATH_FILE + ' - Observable<any> switchMap');
				return this._dataService.liste(
					this._paginator.pageIndex,
					this._paginator.pageSize,
					this._sort.active,
					this._sort.direction,
					this.filter.toLowerCase(),
					this.extra
				);
			}),
			map(data => {
				this._logger.debug(PATH_FILE + ' - Observable<any> map');
				this.isWaitingForResponse = false;
				this.page = data.page;
				this.content = data.content;
				this._logger.debug(PATH_FILE+'- to call afterDataIsLoaded: '+data.content)
				if (this.afterDataIsLoaded != null) 
					this.afterDataIsLoaded();
				return this.content;
			}),
			catchError(() => {
				this.isWaitingForResponse = false;
				return of([]);
			})
		);
	}

	disconnect() {
		this._logger.debug(PATH_FILE + ' - disconnect called doin\' nothing');
	}
}

